import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Specializations from './components/Specializations';
import About from './components/About';
import Treatments from './components/Treatments';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <Navbar />
      <Hero />
      <Specializations />
      <About />
      <Treatments />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
